(() => {
  const STORAGE_KEY = 'ausab_vat_mode';
  const DEFAULT_MODE = 'ex';
  const root = document.documentElement;

  /* ============================
     SET VAT MODE
  ============================ */
  function setVatMode(mode) {
    const m = (mode === 'inc' || mode === 'ex') ? mode : DEFAULT_MODE;

    root.setAttribute('data-vat', m);

    try {
      localStorage.setItem(STORAGE_KEY, m);
    } catch (e) {}

    // Update active button state
    document.querySelectorAll('[data-vat-toggle]').forEach((wrap) => {
      wrap.querySelectorAll('[data-vat-mode]').forEach((btn) => {
        const btnMode = btn.getAttribute('data-vat-mode');
        btn.classList.toggle('is-active', btnMode === m);
      });
    });
  }

  /* ============================
     INIT VAT TOGGLE
     - Use capture + pointerup to avoid drawer/<details> swallowing clicks
  ============================ */
  function initVatToggle() {
    let saved = DEFAULT_MODE;

    try {
      saved = localStorage.getItem(STORAGE_KEY) || DEFAULT_MODE;
    } catch (e) {}

    setVatMode(saved);

    const handler = (e) => {
      const btn = e.target.closest('[data-vat-mode]');
      if (!btn) return;

      // stop accidental <summary>/<details> toggling + theme handlers
      e.preventDefault();
      e.stopPropagation();

      const mode = btn.getAttribute('data-vat-mode');
      if (!mode) return;

      setVatMode(mode);
    };

    // Pointer events (best for mobile)
    document.addEventListener('pointerup', handler, true);

    // Fallback for older browsers
    document.addEventListener('click', handler, true);
  }

  /* ============================
     TOPBAR HIDE ON SCROLL
  ============================ */
  function initTopbarHideOnScroll() {
    const topbar = document.querySelector('.hs-topbar');
    if (!topbar) return;

    const setHeightVar = () => {
      const h = topbar.offsetHeight || 0;
      topbar.style.setProperty('--hs-topbar-h', `${h}px`);
    };

    setHeightVar();

    let lastY = window.scrollY || 0;
    let ticking = false;

    const SHOW_AT_TOP = 8;
    const HIDE_AFTER = 60;

    const onScroll = () => {
      const y = window.scrollY || 0;
      const goingDown = y > lastY;
      const delta = Math.abs(y - lastY);

      if (delta < 2) {
        lastY = y;
        return;
      }

      if (y <= SHOW_AT_TOP) {
        topbar.classList.remove('is-hidden');
        lastY = y;
        return;
      }

      if (goingDown && y > HIDE_AFTER) {
        topbar.classList.add('is-hidden');
      } else {
        topbar.classList.remove('is-hidden');
      }

      lastY = y;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          onScroll();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    window.addEventListener('resize', setHeightVar);
  }

  /* ============================
     Drawer VAT details remember open/close
  ============================ */
  function initVatDrawerDetails() {
    const DETAILS_KEY = 'ausab_vat_drawer_details'; // 'open' | 'closed'
    const details = document.querySelector('[data-vat-details]');
    if (!details) return;

    let saved = null;
    try { saved = localStorage.getItem(DETAILS_KEY); } catch (e) {}

    // First visit: open once (then user choice persists)
    if (!saved) {
      details.open = true;
      try { localStorage.setItem(DETAILS_KEY, 'open'); } catch (e) {}
      return;
    }

    details.open = (saved === 'open');

    details.addEventListener('toggle', () => {
      try { localStorage.setItem(DETAILS_KEY, details.open ? 'open' : 'closed'); } catch (e) {}
    });
  }

  /* ============================
     BOOT
  ============================ */
  document.addEventListener('DOMContentLoaded', () => {
    initVatToggle();
    initTopbarHideOnScroll();
    initVatDrawerDetails();
  });
})();